<template>
  <div>
    <b-table
      :items="results"
      :fields="fields"
      table-class="detail-table"
      responsive
      hover
    >
      <template
        v-for="column in ['thumb', 'preview']"
        #[`cell(${column})`]="{ value, item }"
      >
        <MediaDetailThumb
          :key="column"
          :src="value"
          :unpublished="isHidden(item)"
        />
      </template>
      <template #cell(max_width)="{ value }">
        <span :class="{'text-danger': value < 2000}">{{value}}</span>
      </template>
      <template #cell(max_height)="{ value }">
        <span :class="{'text-danger': value < 2000}">{{value}}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import MediaDetailThumb from '@/components/MediaDetailThumb.vue'

export default {
  name: 'MediaDetail',
  components: {
    MediaDetailThumb,
  },
  props: {
    results: Array,
    showStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fields: [
        {key: 'preview', thClass: 'narrow-column', tdClass: 'text-center'},
        {key: 'max_width', label: 'Width', thClass: 'narrow-column'},
        {key: 'max_height', label: 'Height', thClass: 'narrow-column'},
        'title',
        {key: 'caption', label: 'Description'},
        'keywords',
      ],
    }
  },
  computed: {},
  methods: {
    isHidden(item) {
      return this.showStatus && !item?.published
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .detail-table {
  th, td {
    white-space: nowrap;
  }
  > tbody > tr > td {
    padding-top: 3px;
    padding-bottom: 3px;
    vertical-align: middle;
  }
}

/deep/ .narrow-column {
  width: 70px;
}
</style>
